




































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { realizedColumns, currencyMap, permil, calValue } from '@/utils/finance';

@Component({
  components: {}
})
class RealizedTable extends Vue {
  realizedColumns: any[] = realizedColumns;
  realizedData: any[] = [];
  calValue = calValue;

  get realized() {
    return this.$store.state.middlePageDetail.realized;
  }

  @Watch('realized')
  initRealized(dataList) {
    let cnyTotalInfo: any = {
      investmentCost: 0,
      shareNum: 0,
      sharePercent: 0,
      proceeds: 0
    };
    let usdTotalInfo: any = {
      investmentCost: 0,
      shareNum: 0,
      sharePercent: 0,
      proceeds: 0
    };
    let finalList = dataList.reduce((list, fundItem) => {
      let { currency, investmentCost, shareNum, sharePercent, proceeds, penetrateProjectVos, returnMultiple } = fundItem;

      list.push({
        ...fundItem,
        currencyText: currencyMap[currency],
        investmentCostText: permil(investmentCost),
        shareNumText: permil(shareNum, 2, true),
        proceedsText: permil(proceeds),
        sharePercentText: (sharePercent * 100).toFixed(2) + '%',
        returnMultiple: returnMultiple === null || returnMultiple === undefined ? '' : returnMultiple.toFixed(4)
      });
      if (currency === 1) {
        cnyTotalInfo.investmentCost = cnyTotalInfo.investmentCost + investmentCost;
        cnyTotalInfo.shareNum = cnyTotalInfo.shareNum + shareNum;
        cnyTotalInfo.sharePercent = cnyTotalInfo.sharePercent + sharePercent;
        cnyTotalInfo.proceeds = cnyTotalInfo.proceeds + proceeds;
      } else if (currency === 2) {
        usdTotalInfo.investmentCost = usdTotalInfo.investmentCost + investmentCost;
        usdTotalInfo.shareNum = usdTotalInfo.shareNum + shareNum;
        usdTotalInfo.sharePercent = usdTotalInfo.sharePercent + sharePercent;
        usdTotalInfo.proceeds = usdTotalInfo.proceeds + proceeds;
      }

      if (penetrateProjectVos.length > 0) {
        penetrateProjectVos.forEach(penetrateItem => {
          let { currency, investmentCost, shareNum, sharePercent, proceeds, returnMultiple } = penetrateItem;
          let item = {
            penetrateFund: penetrateItem,
            currencyText: currency,
            investmentCostText: permil(investmentCost),
            shareNumText: permil(shareNum, 2, true),
            proceedsText: permil(proceeds),
            sharePercentText: (sharePercent * 100).toFixed(2) + '%',
            returnMultiple: returnMultiple === null || returnMultiple === undefined ? '' : returnMultiple.toFixed(4)
          };
          list.push(item);
        });
      }
      return list;
    }, []);
    if (finalList.length > 0) {
      let cnyTotalItem = {
        classOfShare: '合计',
        currencyText: 'CNY',
        investmentCostText: permil(cnyTotalInfo.investmentCost),
        shareNumText: permil(cnyTotalInfo.shareNum, 2, true),
        proceedsText: permil(cnyTotalInfo.proceeds),
        sharePercentText: (cnyTotalInfo.sharePercent * 100).toFixed(2) + '%',
        returnMultiple: +cnyTotalInfo.investmentCost ? (cnyTotalInfo.proceeds / cnyTotalInfo.investmentCost).toFixed(4) : ''
      };
      let usdTotalItem = {
        classOfShare: '合计',
        currencyText: 'USD',
        investmentCostText: permil(usdTotalInfo.investmentCost),
        shareNumText: permil(usdTotalInfo.shareNum, 2, true),
        proceedsText: permil(usdTotalInfo.proceeds),
        sharePercentText: (usdTotalInfo.sharePercent * 100).toFixed(2) + '%',
        returnMultiple: +usdTotalInfo.investmentCost ? (usdTotalInfo.proceeds / usdTotalInfo.investmentCost).toFixed(4) : ''
      };

      finalList.unshift(usdTotalItem);
      finalList.unshift(cnyTotalItem);
    }
    this.realizedData = finalList;
  }

  toFMV(fund) {
    let { type, id } = fund;
    if (type !== 2) {
      window.open(`/finance/fairvalueTable?fundId=${id}`);
    } else {
      this.$message.warn('SPV无法跳转FMV');
    }
  }
}

export default RealizedTable;
